import React from 'react'

import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import ImpressumSeite from '../components/impresum'
import Footer from '../components/footer'
import './datenschutz.css'

const Impressum = (props) => {
  return (
    <div className="datenschutz-container">
      <Helmet>
        <title>Impressum</title>
        <meta
          property="og:title"
          content="Datenschutz - All Obedient Rhinoceros"
        />
        <link
          rel="canonical"
          href="https://all-obedient-rhinoceros-5cbetl.teleporthq.app/datenschutz"
        />
      </Helmet>
      <Navigation rootClassName="navigationroot-class-name1"></Navigation>
      <ImpressumSeite rootClassName="textroot-class-name1"></ImpressumSeite>
      <Footer rootClassName="footerroot-class-name1"></Footer>
    </div>
  )
}

export default Impressum
